export default "__VITE_ASSET__DemcCk7$__"